import { excludedComponents } from './../../application/pageDataObject'
const INITIAL_STATE = {
  excludedComponentsForSite: excludedComponents,
}

export function featureFlagReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/featureFlags/featureFlags.reducers.js